import React from 'react';

const Revisional = () => {
    return (
        <div className='container-calculo'>
            <div className='label-calculo'>
                <h1 className='titulo-calculo'>Revisional</h1>
            </div>
        </div>
    );
};

export default Revisional;